<template>
  <el-tooltip effect="dark" :content="item.label" placement="top">
    <div class="padding-5 pointer flex-center" @click="setTableBorder">
      <img :src="item.icon" :style="{ width: item.size + 'px', height: item.size + 'px' }" />
    </div>
  </el-tooltip>
</template>
<script >
const __sfc_main = {};
__sfc_main.props = {
  item: {
    type: Object,
    default: () => {}
  }
};
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
